import { useContext } from 'react';

import type { CoordinatedTooltipOptions } from '../context';
import { CoordinatedTooltipContext } from '../context';

export type UseCoordinatedTooltipContext = () => CoordinatedTooltipOptions;
export const useCoordinatedTooltipContext: UseCoordinatedTooltipContext = () => useContext(CoordinatedTooltipContext);
